import { formatInTimeZone } from "date-fns-tz";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import DateRangeComp from "../../common/DateRangeComp";
import * as actions from "../redux/ReportAction";

export const PromotionReport = ({ promotionId }) => {
  const intl = useIntl();
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const timeZone = "Asia/Kuala_Lumpur";
  const dispatch = useDispatch();
  const reportState = useSelector(({ report }) => report, shallowEqual);
  const customCardClass =
    "rounded d-flex align-items-center justify-content-spacebetween py-2";

  useEffect(() => {
    handleSearchClick();

    return () => dispatch(actions.clearPromotionReport());
  }, []);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  const handleSearchClick = () => {
    if (promotionId) {
      const queryParams = {
        action: "promotionreport",
        promotionid: promotionId,
        fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
        todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
      };

      dispatch(actions.fetchPromotionReport(queryParams));
    }
  };

  return (
    <div>
      <div className="dateSearch-div">
        <div className="dateRange-div border rounded">
          <DateRangeComp
            initialRange={[
              { startDate: fromDate, endDate: toDate, key: "selection" },
            ]}
            onDateChange={handleDateChange}
          />
        </div>
        <div className="d-flex align-items-center gap-2">
          {reportState.actionsLoading && (
            <div
              className="spinner-border me-2"
              role="status"
              style={{ scale: "0.55" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
          <button className="btn btn-primary" onClick={handleSearchClick}>
            {intl.formatMessage({ id: "search" })}
          </button>
        </div>
      </div>
      {reportState.promotionReport && (
        <div
          className={`${customCardClass} gamelistDiv1 cursor-pointer position-relative text-center mobile-overflow`}
          style={{
            border: "1px solid grey",
            padding: "2px",
            margin: "10px 0 ",
          }}
        >
          <div style={{ width: "100%" }}>
            <table
              className="text-start table-report"
              style={{
                width: "100%",
                minWidth: "1000px",
              }}
            >
              <tbody>
                <tr>
                  <td className="col-3  td-line">
                    {intl.formatMessage({ id: "claimCount" }) +
                      " : " +
                      reportState.promotionReport.totalcount}
                  </td>
                  <td className="col-3 td-line">
                    {intl.formatMessage({ id: "claimAmount" }) +
                      " : " +
                      reportState.promotionReport.totalclaim}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="member-div d-flex" style={{ margin: "10px auto" }}>
        <div className="member-container">
          <div className="table-responsive">
            <table className="member-table">
              <thead className="member-header1">
                <tr className="member-row1">
                  <th className="member-cell hide-on-mobile">
                    {intl.formatMessage({ id: "no" })}
                  </th>
                  <th className="member-cell text-start text-nowrap">
                    {intl.formatMessage({ id: "username" })}
                  </th>
                  <th className="member-cell text-end">
                    {intl.formatMessage({ id: "claimCount" })}
                  </th>
                  <th className="member-cell text-end">
                    {intl.formatMessage({ id: "claimAmount" })}
                  </th>
                </tr>
              </thead>
              <tbody className="member-body">
                {reportState.promotionReport?.freeCreditReports.length > 0 ? (
                  reportState.promotionReport?.freeCreditReports.map(
                    (report, index) => (
                      <tr key={index} className="member-row1">
                        <td className="member-cell hide-on-mobile">
                          {index + 1}
                        </td>
                        <td className="member-cell text-start">
                          {report.username}
                        </td>
                        <td className="member-cell text-end">
                          {report.claimcount}
                        </td>
                        <td className="member-cell text-end">
                          {report.claimamount}
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan="4">
                      <div className="no-record-wrapper oRecordDiv">
                        <i className="bi bi-search fs-1 mb-3" />
                        <div className="text-font2">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
